import { Observable } from 'rxjs';
import { Decimal } from '@taxfyle/api-internal/shared/types/decimal_pb';
var nanoFactor = 1000000000;

/**
 * Converts a proto Timestamp to an ISO8601 string date
 * @param timestamp The timestamp to convert either in Timestamp protobuf
 * format or as an object
 */
export function timestampToISO(timestamp) {
  if (!timestamp) {
    return timestamp;
  }
  if ('toDate' in timestamp) {
    return timestamp.toDate().toISOString();
  } else {
    return new Date(timestamp.seconds * 1000 + timestamp.nanos / 1000000).toISOString();
  }
}

/**
 * Converts a proto custom Decimal type into a Number
 * @param decimal The decimal to convert either in Decimal protobuf format or as
 * an object
 */
export function decimalToNumber(decimal) {
  if ('getUnits' in decimal) {
    return decimal.getUnits() + decimal.getNanos() / nanoFactor;
  } else {
    return decimal.units + decimal.nanos / nanoFactor;
  }
}

/**
 * Converts a proto duration into minutes.
 *
 * @param {*} duration
 * @returns
 */
export function durationToMinutes(duration) {
  if ('getSeconds' in duration) {
    return (duration.getSeconds() + duration.getNanos() / nanoFactor) / 60;
  } else {
    return (duration.seconds + duration.nanos / nanoFactor) / 60;
  }
}

/**
 * Converts a Number into a proto custom Decimal type
 *
 * @param number The number to convert to a decimal.
 */
export function numberToDecimal(number) {
  var decimal = new Decimal();
  var units = Math.floor(number);
  var nanos = Math.floor((number - units) * nanoFactor);
  decimal.setUnits(units);
  decimal.setNanos(nanos);
  return decimal;
}

/**
 * Enables grpc-web dev tools on the specified clients
 */
export function enableDevTools() {
  var enableDevTools = window.__GRPCWEB_DEVTOOLS__;
  if (enableDevTools) {
    for (var _len = arguments.length, clients = new Array(_len), _key = 0; _key < _len; _key++) {
      clients[_key] = arguments[_key];
    }
    enableDevTools(clients);
  }
}

/**
 * Gets an observable from a streaming call.
 *
 * @param start Factory function to start the streaming call when subscribed to.
 * @param errorOnEnd If `true`, emits an error when the call is ended by the
 *  server. Default is `false`.
 * @returns {Observable}
 */
export function fromStreamingCall(start) {
  var errorOnEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Observable(function (observer) {
    var streamingCall = start();
    streamingCall.on('data', function (response) {
      observer.next(response);
    });
    if (errorOnEnd) {
      streamingCall.on('end', function () {
        observer.error(new Error('Streaming call ended'));
      });
    }
    streamingCall.on('error', function (err) {
      observer.error(err);
    });
    return function () {
      streamingCall.cancel();
    };
  });
}
//# sourceMappingURL=grpcUtil.js.map
